import { useAutomationLinkedInStatus } from './useAutomationLinkedInStatus'

function useNeedsLinkedInReauth() {
	const { isFetching, isSignedOut, isSuccess, linkedProfileExist } =
		useAutomationLinkedInStatus()

	if (!linkedProfileExist) {
		const result = {
			isLoading: false,
			needsReauth: false
		}
		return result
	}

	if (isFetching || !isSuccess) {
		const result = {
			isLoading: true,
			needsReauth: false
		}
		return result
	}

	const result = {
		isLoading: false,
		needsReauth: isSignedOut
	}
	return result
}

export { useNeedsLinkedInReauth }
